<template>
  <!-- 注册 -->
  <div id="register">
    <div class="register-img">
      <img src="./images/组 2813.png" alt />
    </div>
    <!-- 代办优势 -->
    <div class="advantage">
      <h2 class="advantage-h2">中税代办注册优势</h2>
      <div class="advantage-items">
        <div class="item">
          <img src="./images/蒙版组 12.png" alt />
          <div class="item-text">
            <h3>在线核名</h3>
            <p>省时省心省力</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 39.png" alt />
          <div class="item-text">
            <h3>全程代办</h3>
            <p>专岗专人专业</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 40.png" alt />
          <div class="item-text">
            <h3>后续服务</h3>
            <p>做账报税筹划</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 44.png" alt />
          <div class="item-text">
            <h3>工商批准</h3>
            <p>法定地址挂靠</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 准备资料 -->
    <div class="quality">
      <h2 class="quality-h2">准备资料</h2>
      <div class="quality-items">
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2738.png" alt />
          </div>
          <p>公司名称（3个以上公司备选名称）</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2739.png" alt />
          </div>
          <p>公司注册地址房产证复印件</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2740.png" alt />
          </div>
          <p>全体股东身份证</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2741.png" alt />
          </div>
          <p>确定注册资金和股东出资比例</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2742.png" alt />
          </div>
          <p>公司经营范围</p>
        </div>
      </div>
    </div>
    <!-- 公司注册流程 -->
    <div class="process">
      <h2 class="process-h2">公司注册流程</h2>
      <div class="process-link">
        <div class="process-imga">
          <img src="./images/路径 2898.png" alt="">
        </div>
        <!-- 元素 -->
        <div class="process-item item1">
          <h3>名称核实</h3>
          <img src="./images/组 2814.png" alt="">
        </div>
        <div class="process-item item2">
          <h3>信息填报</h3>
          <img src="./images/组 2815.png" alt="">
        </div>
        <div class="process-item item3">
          <h3>提交信息</h3>
          <img src="./images/组 2816.png" alt="">
        </div>
        <div class="process-item item4">
          <h3>等待审批</h3>
          <img src="./images/组 2817.png" alt="">
        </div>
        <div class="process-item item5">
          <img src="./images/组 2818.png" alt="">
          <h3>领取执照</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.register-img {
  width: 100%;
  min-width: 1040px;
  img {
    width: 100%;
  }
}
// 代办优势
.advantage {
  // width: 100%;
  width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  // padding: 0 20%;
  box-sizing: border-box;
  padding-bottom: 50px;
  .advantage-h2 {
    padding: 30px 0;
  }
  .advantage-items {
    display: flex;
    justify-content: space-between;
    .item {
      width: 24%;
      box-sizing: border-box;
      img {
        width: 100%;
      }
      .item-text {
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        padding: 20px 0;
        margin-right: -1px;
        border: 1px solid rgb(238, 238, 238);
        h3 {
          line-height: 30px;
        }
        p {
          color: #6f6f6f;
        }
      }
    }
  }
}
.quality {
  width: 100%;
  // min-width: 1040px;
  // margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding: 0 20%;
  box-sizing: border-box;
  background-color: rgb(240, 240, 240);
  padding-bottom: 50px;
  .quality-h2 {
    padding: 30px 0;
  }
  .quality-items {
    // width: 100%;
    width: 1040px;
    margin: 0 auto;
    height: 200px;
    display: flex;
    justify-content: space-between;
    .item {
      width: 19%;
      display: flex;
      flex-direction: column;
      // justify-content: space-evenly;
      align-items: center;
      background-color: #fff;
      text-align: center;
      box-sizing: border-box;
      padding: 0 10px;
      box-shadow: 1px 1px 4px #dddddd;
      .item-img {
        margin-top: 30px;
        margin-bottom: 40px;
        width: 35%;
        font-size: 11px;
        img {
          width: 100%;
        }
      }
    }
  }
}
// 注册流程
.process {
  min-width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20%;
  padding-bottom: 100px;
  box-sizing: border-box;
  .process-h2 {
    padding-bottom: 100px;
  }
  .process-link {
    width: 900px;
    position: relative;
    .process-imga {
      position: relative;
      width: 100%;
      img {
        width: 100%;
      }
    }
    .process-item {
      width: 60px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      img {
        width: 100%;
      }
      h3 {
        margin-bottom: 20px;
      }
    }
    .item1 {
      position: absolute;
      top: -65px;
      left: -10px;
    }
    .item2 {
      position: absolute;
      top: -65px;
      left: 30%;
    }
    .item3 {
      position: absolute;
      top: -65px;
      right: 32%;
    }
    .item4 {
      position: absolute;
      top: -65px;
      right: 5%;
    }
    .item5 {
      position: absolute;
      bottom: -82px;
      right: 16%;
      h3 {
        margin-top: 20px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/inAndOut/register/register.vue